/**
 * Returns true when catch-up is available for the full event:
 * the event already ended and both start and end fall inside the catch-up window.
 *
 * Returns false when:
 * - the event is still live / not finished
 * - the event ended more than `hours` ago
 * - the catch-up window start falls inside the event (started before the window)
 *
 * @param {number} hours Catch-up window in hours
 * @param {string|number|Date} startDateEvent Event start time
 * @param {string|number|Date} endDateEvent Event end time
 * @return {boolean}
 */
export const checkExpiredCatchUpContent = (
  hours,
  startDateEvent,
  endDateEvent,
) => {
  // Backward compatible: (hours, endDateEvent) when start is omitted
  if (endDateEvent == null && startDateEvent != null) {
    endDateEvent = startDateEvent;
    startDateEvent = null;
  }

  if (hours == null || hours < 0 || !endDateEvent) return false;

  const endDate = new Date(endDateEvent).getTime();
  if (Number.isNaN(endDate)) return false;

  const now = Date.now();
  const windowStart = now - hours * 60 * 60 * 1000;

  // Still live / not finished → no catch-up
  if (endDate > now) return false;

  // Ended before the catch-up window → no catch-up
  if (endDate < windowStart) return false;

  if (startDateEvent != null) {
    const startDate = new Date(startDateEvent).getTime();
    if (Number.isNaN(startDate)) return false;

    // Catch-up window start falls inside the event → incomplete catch-up → false
    if (startDate < windowStart) return false;
  }

  return true;
};
